module.exports = __webpack_public_path__ + "img/selected1-min.bee035f3.png";